import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectUserLogin = createDeepEqualSelector(selectAuth, (auth) => auth.login);

export const selectSuccessRedirect = createDeepEqualSelector(selectUserLogin, (login) => login.successRedirect);
